import { Outlet, useSearchParams } from "react-router-dom";
import { ThemeProvider, Theme, initialValue } from "../context/ThemeProvider";
import i18n, { supportedLanguages } from "../i18n";
export const AppWrapper = () => {
  const [params] = useSearchParams();

  const theme: Theme = {
    primaryColor: params.get("primaryColor") ?? initialValue.primaryColor,
    secondaryColor: params.get("secondaryColor") ?? initialValue.secondaryColor,
  };

  const paramLanguage = params.get("language");
  if (paramLanguage && supportedLanguages.includes(paramLanguage)) {
    i18n.changeLanguage(paramLanguage);
  }

  return (
    <ThemeProvider value={theme}>
      <Outlet />
    </ThemeProvider>
  );
};
